export default {
  appointmentContainer: {
    title: 'Planifiquemos la reparación',
    text: 'Nuestros reparadores están disponibles en los siguientes días',
    text2: 'Estos huecos corresponden a la hora prevista de llegada del profesional.',
    actions: {
      primary: 'Confirmar cita',
      secondaryHelpText: '¿Ninguno de estas opciones es adecuado para ti?',
      secondary: 'Me gustaría que me llamaran de nuevo'
    },
    dates: {
      months: {
        january: 'Enero',
        february: 'Febrero',
        march: 'Marzo',
        april: 'Abril',
        may: 'Mayo',
        june: 'Junio',
        july: 'Julio',
        august: 'Agosto',
        september: 'Septiembre',
        october: 'Octubre',
        november: 'Noviembre',
        december: 'Diciembre'
      }
    },
    notifications: {
      errors: {
        getSchedule: 'Error! No se ha podido recuperar los días disponibles para agendar una cita.',
        postAppointment: 'Error! No se ha podido agendar la cita seleccionada.',
        postContact: 'Error! No se ha podido solicitar el contacto.'
      }
    }
  }
}
